import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface MessagesAnalyticsCache {
  data: any[]
  updatedAt: number
}

interface State {
  cache: Record<string, MessagesAnalyticsCache>
  getCache: (key: string) => MessagesAnalyticsCache | undefined
  setCache: (key: string, data: MessagesAnalyticsCache) => void
  clear: () => void
}

export const useMessagesAnalyticsCacheStore = create<State>()(
  persist(
    (set, get) => ({
      cache: {},
      getCache: key => get().cache[key],
      setCache: (key, data) =>
        set(state => ({
          cache: {
            ...state.cache,
            [key]: data
          }
        })),
      clear: () => set({ cache: {} }) 
    }),
    {
      name: 'messages-analytics-cache'
    }
  )
)
